/* ============================================================
KENSONS CUSTOM – Dynamic Valentine strike price on COLLECTION (Venue)
- Creates .kensons-dyn-price automatically
- Reads original price from .money
- Shows compare (strikethrough) + sale (red)
- Ensures ONLY our dyn price is visible in .product-card__price-inline
  (removes duplicate original price line)
- Re-runs on DOM updates (filters/sorting)
============================================================ */

(function () {
  const DISCOUNT_DEFAULT = 14;

  function getDiscountPercent() {
    const anchor = document.querySelector(".kensons-dynstrike-collection");
    const p = Number(anchor?.getAttribute("data-dynstrike") || DISCOUNT_DEFAULT);
    return Number.isFinite(p) && p > 0 ? p : DISCOUNT_DEFAULT;
  }

  function parseEuroToCents(text) {
    const t = (text || "").trim();
    const m = t.match(/(\d{1,3}(?:\.\d{3})*|\d+)([.,]\d{2})/);
    if (!m) return null;
    const intPart = m[1].replace(/\./g, "");
    const decPart = m[2].replace(",", ".");
    const n = Number(`${intPart}${decPart}`);
    if (Number.isNaN(n)) return null;
    return Math.round(n * 100);
  }

  function formatCentsToEuro(cents) {
    const euros = (cents / 100).toFixed(2);
    const [i, d] = euros.split(".");
    const withThousands = i.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return `${withThousands},${d} €`;
  }

  function isValentineCard(card) {
    return (card.textContent || "").toLowerCase().includes("valentine");
  }

  function ensureDynPriceEl(card) {
    const priceInline = card.querySelector(".product-card__price-inline");
    const container = priceInline || card.querySelector(".product-card__title-price-row") || card;

    if (!container) return null;

    let el = container.querySelector(":scope > .kensons-dyn-price") || container.querySelector(".kensons-dyn-price");
    if (el) return el;

    el = document.createElement("div");
    el.className = "kensons-dyn-price";
    el.style.display = "inline-flex";
    el.style.alignItems = "baseline";
    el.style.gap = "10px";
    el.style.whiteSpace = "nowrap";
    el.style.marginLeft = "auto";
    el.style.textAlign = "right";

    // Put our element at the start of the price area if possible
    if (priceInline) {
      priceInline.insertBefore(el, priceInline.firstChild);
    } else {
      container.appendChild(el);
    }

    return el;
  }

  function keepOnlyDynPriceVisible(card) {
    const priceInline = card.querySelector(".product-card__price-inline");
    if (!priceInline) return;

    // Hide ALL direct children except our dyn price
    Array.from(priceInline.children).forEach((child) => {
      if (child.classList.contains("kensons-dyn-price")) {
        child.style.display = "inline-flex";
      } else {
        child.style.display = "none";
      }
    });

    // Extra safety: if theme injects stray .money elsewhere in the inline area, hide it too
    Array.from(priceInline.querySelectorAll(".money")).forEach((m) => {
      if (!m.closest(".kensons-dyn-price")) m.style.display = "none";
    });
  }

  function applyToCard(card, discountPercent) {
    const moneyEl = card.querySelector(".money");
    if (!moneyEl) return;

    const originalCents = parseEuroToCents(moneyEl.textContent);
    if (originalCents == null) return;

    const saleCents = Math.round(originalCents * (1 - discountPercent / 100));

    const targetEl = ensureDynPriceEl(card);
    if (!targetEl) return;

    targetEl.innerHTML =
      `<span class="kensons-dyn-compare" style="text-decoration:line-through; opacity:.55; text-decoration-thickness:2px;">${formatCentsToEuro(originalCents)}</span>` +
      `<span class="kensons-dyn-now" style="color:#b00020; font-weight:700;">${formatCentsToEuro(saleCents)}</span>`;

    // Now kill duplicates in the price-inline block
    keepOnlyDynPriceVisible(card);
  }

  function run() {
    const anchor = document.querySelector(".kensons-dynstrike-collection");
    if (!anchor) return;

    const discountPercent = getDiscountPercent();

    document.querySelectorAll("article, .product-card").forEach((card) => {
      if (!isValentineCard(card)) return;
      applyToCard(card, discountPercent);
    });
  }

  document.addEventListener("DOMContentLoaded", run);

  new MutationObserver(() => {
    window.requestAnimationFrame(run);
  }).observe(document.body, { childList: true, subtree: true });
})();
